import ApiService from './api.service';

class OrderService {
  async list(limit = 10, page = 1, search = '', status = 'success') {
    try {
      const response = await ApiService.get(`/orders?limit=${limit}&page=${page}&search=${search}&status=${status}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async show(id) {
    try {
      const response = await ApiService.get(`/orders/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async checkTransactions(formData) {
    try {
      console.log('Envoi de la requête avec FormData:', formData);
      const response = await ApiService.postFormData('/orders/check-transactions', formData);
      console.log('Réponse brute:', response);
      return response;
    } catch (error) {
      console.error('Erreur service:', error);
      throw error;
    }
  }

  async verifyPayment(payload) {
    try {
      const response = await ApiService.post('/shop/verify-payment', payload);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async verifyTransaction(data) {
    try {
      console.log('Envoi de la requête de vérification:', data);
      const response = await ApiService.post('/orders/verify-transaction', {
        transaction_id: data.transaction_id,
        provider: data.provider
      });
      console.log('Réponse brute du serveur:', response);
      return response;
    } catch (error) {
      console.error('Erreur dans verifyTransaction:', error);
      throw error.response?.data || error;
    }
  }

  async refundOrder(payload) {
    try {
      const response = await ApiService.post('/orders/refund', payload);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async resendOrderEmail(order_id, new_email) {
    try {
      const response = await ApiService.post('/shop/resend-order', { order_id, new_email });
      return response;
    } catch (error) {
      throw error;
    }
  }

  async exportOrdersExcel() {
    return await ApiService.fetchBlob('/export/orders/excel');
  }

  async regenerateInvoice(order_reference, options = {}) {
    try {
      const response = await ApiService.post('/shop/regenerate-invoice', { order_reference, ...options });
      return response;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
}

export default new OrderService();